import { render, staticRenderFns } from "./apilist.vue?vue&type=template&id=3586100d"
import script from "./apilist.vue?vue&type=script&lang=js"
export * from "./apilist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports